import React from "react";

export default function AddSvg(props) { 
    const svgContent = { __html: props.svg};
    
    return (
        <div dangerouslySetInnerHTML={svgContent} />
    )
} 